module.exports = __webpack_public_path__ + "img/quote-bottom.0dce47b8.svg";